import React from "react";
import "./Services.css";
import graphic from "./graphic.png";
import codingImg from "./codingImg.png";
import webDesign from "./webDesign.png";
import Footer from "./Footer";

function Services() {
  return (
    <div>
      <section className="services" id="services">
        <div className="row">
          {/* <h2 className="section-heading">Our Services</h2> */}
          <p className="text-blk team-head-text" style={{ color: "#37517e" }}>
            Our Services
          </p>
          <p
            style={{
              color: "gray",
              textAlign: "center",
              margin: "-20px auto 60px auto",
              width:"70vw"
            }}
          >
            Lorem, ipsum dolor sit amet consectetur adipisicing elit. Illo atque
            recusandae optio commodi praesentium nostrum nam facilis perferendis
            in quasi. Aut nobis numquam, iusto temporibus laudantium facilis
            delectus in iure!
          </p>
        </div>
        <div className="row">
          <div className="column">
            <div className="card">
              <img src={codingImg} alt="" className="services__icon" />
              <h3>Web Development</h3>
              <p>
                Crafting captivating websites with clean, modern design. Let's
                make your online vision a reality.
              </p>
            </div>
          </div>
          <div className="column">
            <div className="card">
              <img src={graphic} alt="" className="services__icon" />

              <h3>Graphic Design</h3>
              <p>
                Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                Quisquam consequatur necessitatibus eaque.
              </p>
            </div>
          </div>
          <div className="column">
            <div className="card">
              <img src={webDesign} alt="" className="services__icon" />
              <h3>Web Design</h3>
              <p>
                Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                Quisquam consequatur necessitatibus eaque.
              </p>
            </div>
          </div>
          <div className="column">
            <div className="card">
              <img src={codingImg} alt="" className="services__icon" />
              <h3>Service Heading</h3>
              <p>
                Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                Quisquam consequatur necessitatibus eaque.
              </p>
            </div>
          </div>
          <div className="column">
            <div className="card">
              <div className="icon-wrapper">
                <i className="fas fa-broom"></i>
              </div>
              <h3>Service Heading</h3>
              <p>
                Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                Quisquam consequatur necessitatibus eaque.
              </p>
            </div>
          </div>
          <div className="column">
            <div className="card">
              <div className="icon-wrapper">
                <i className="fas fa-plug"></i>
              </div>
              <h3>Service Heading</h3>
              <p>
                Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                Quisquam consequatur necessitatibus eaque.
              </p>
            </div>
          </div>
        </div>
      </section>
      <Footer/>
    </div>
  );
}

export default Services;
